import { ApplicationStatus } from '../enums/application-status';
import { AllowedActionsMap, StateMachine, TransitionMap } from './state-machine';

// Domain + UI actions (UI actions don’t affect transitions)
export type ApplicationAction =
  | 'Submit'
  | 'Return'
  | 'Resubmit'
  | 'Comply'
  | 'Review'
  | 'Approve'
  | 'Reject'
  // UI-only helpers:
  | 'Edit'
  | 'Delete'
  | 'CreateProject';

// --- EXACT MIRROR of EnsureValidTransition on server ---
const transitions: TransitionMap<ApplicationStatus> = {
  [ApplicationStatus.Draft]: [
    ApplicationStatus.Submitted
  ],

  [ApplicationStatus.Submitted]: [
    ApplicationStatus.Returned,
    ApplicationStatus.InCompliance,
    ApplicationStatus.NonCompliance,
    ApplicationStatus.Rejected,
  ],

  [ApplicationStatus.Returned]: [
    ApplicationStatus.Resubmitted
  ],

  [ApplicationStatus.Resubmitted]: [
    ApplicationStatus.Returned,
    ApplicationStatus.InCompliance,
    ApplicationStatus.NonCompliance,
    ApplicationStatus.Rejected,
  ],

  [ApplicationStatus.InCompliance]: [
    ApplicationStatus.PositiveReview,
    ApplicationStatus.NegativeReview,
    ApplicationStatus.InCompliance,
    ApplicationStatus.NonCompliance,
    ApplicationStatus.Rejected,
  ],

  [ApplicationStatus.NonCompliance]: [
    ApplicationStatus.InCompliance,
    ApplicationStatus.NonCompliance,
    ApplicationStatus.Rejected,
  ],

  [ApplicationStatus.PositiveReview]: [
    ApplicationStatus.NegativeReview,
    ApplicationStatus.PositiveReview,
    ApplicationStatus.Approved,
    ApplicationStatus.Rejected,
  ],

  [ApplicationStatus.NegativeReview]: [
    ApplicationStatus.NegativeReview,
    ApplicationStatus.PositiveReview,
    ApplicationStatus.Rejected,
  ],
  // Approved & Rejected are terminal
};


const allowedActions: AllowedActionsMap<ApplicationStatus, ApplicationAction> = {
  [ApplicationStatus.Draft]: ['Submit', 'Edit', 'Delete'],

  [ApplicationStatus.Submitted]: ['Return', 'Reject', 'Comply'],

  [ApplicationStatus.Returned]: ['Resubmit', 'Edit'],

  [ApplicationStatus.Resubmitted]: ['Return', 'Reject', 'Comply'],

  [ApplicationStatus.InCompliance]: ['Comply', 'Review', 'Reject'],

  [ApplicationStatus.NonCompliance]: ['Comply', 'Reject'],

  [ApplicationStatus.PositiveReview]: ['Review', 'Approve', 'Reject'],

  [ApplicationStatus.NegativeReview]: ['Review', 'Reject'],

  [ApplicationStatus.Approved]: ['CreateProject'],

  [ApplicationStatus.Rejected]: [],
};

export const ApplicationStateMachine = new StateMachine<ApplicationStatus, ApplicationAction>({
  transitions,
  allowedActions,
});